/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type SvuOwnerDocsClosePartialUpdateRequest = {} | null | undefined;
export type SvuOwnerDocsClosePartialUpdateResponse = any;

export type SvuOwnerDocsClosePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/svu_owner_docs/{id}/close/
 *
 * ```yaml
 * operationId: svu_owner_docs_close_partial_update
 * tags:
 *   - svu_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuOwnerDocsClosePartialUpdateOperation = ({
  id,
  ...rest
}: SvuOwnerDocsClosePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/svu_owner_docs/${id}/close/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/svu_owner_docs/{id}/close/' };
  };

/**
 * PATCH /dmx-server/svu_owner_docs/{id}/close/
 *
 * ```yaml
 * operationId: svu_owner_docs_close_partial_update
 * tags:
 *   - svu_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const svuOwnerDocsClosePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SvuOwnerDocsClosePartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = svuOwnerDocsClosePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
